import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from './context/ThemeContext';
import './i18n'; // подключаем локализацию
import { SnackbarProvider } from 'notistack';
import { NotificationProvider } from './context/NotificationContext';
import 'ag-grid-community/styles/ag-grid.css';        // основной CSS
import 'ag-grid-community/styles/ag-theme-alpine.css'; // тема “Alpine”



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider> 
      <NotificationProvider>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
        <App />
        </SnackbarProvider>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
